import apiClient from '../apiClient';

class InvoiceIssuerService {
  async getAll() {
    const response = await apiClient.get('/invoice-issuers');
    return response || [];
  }

  async create(data) {
    return await apiClient.post('/invoice-issuers', data);
  }

  async update(id, data) {
    return await apiClient.patch(`/invoice-issuers/${id}`, data);
  }

  async delete(id) {
    return await apiClient.delete(`/invoice-issuers/${id}`);
  }

  async getLogoUploadUrl(id, fileName, contentType) {
    return await apiClient.post(`/invoice-issuers/${id}/logo-upload-url`, {
      fileName,
      contentType,
    });
  }

  async uploadLogo(id, file) {
    const { uploadUrl } = await this.getLogoUploadUrl(id, file.name, file.type);

    const uploadResponse = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': file.type },
    });

    if (!uploadResponse.ok) {
      throw new Error('Failed to upload logo');
    }

    return true;
  }
}

export default InvoiceIssuerService;
